import React from 'react';
import ReactDOM from 'react-dom';
import MLHSearch from './MLHSearch';

ReactDOM.render(<MLHSearch />, document.getElementById('root'));
